<div
  class="app-shell"
  [class.consent-blocked]="isConsentBlocking()"
  [attr.inert]="isConsentBlocking() ? '' : null"
  [attr.aria-hidden]="isConsentBlocking() ? 'true' : null"
>
  <app-navbar />
  <router-outlet />
</div>
<app-consent-modal />
<app-update-notification />
